<template>
  <div class="guestInfo-bottomPrice">
    <div class="orderNotesAgreeCon">
      <div class="agreeCheckBtnItem">
        <span
          class="agreeCheckBtn"
          :class="{ active: isAgreePolicy }"
          @click="isAgreePolicy = !isAgreePolicy"
        >
          <i class="f7-icons">{{
            isAgreePolicy ? "check_round_fill" : "circle"
          }}</i>
        </span>
        <span class="agreeCheckTxt"
          >我确认乘客信息填写正确，已阅读并同意</span
        >
        <a
          class="agreeCheckLink js-policy01"
          id="openContract"
          @click="showPrivacy(0)"
          >《乘客票据合同》</a
        >
  <!--      <span class="agreeCheckTxt">和</span>-->
  <!--      <a-->
  <!--        class="agreeCheckLink js-policy02"-->
  <!--        id="openPrivacy"-->
  <!--        @click="showPrivacy(1)"-->
  <!--        >《新冠防护隐私政策》</a-->
  <!--      >-->
      </div>
      <div class="agreeCheckBtnItem">
        <span
            class="agreeCheckBtn"
            :class="{ active: marketingFlagChecked }"
            @click="marketingFlagChecked = !marketingFlagChecked"
        >
          <i class="f7-icons">{{
              marketingFlagChecked ? "check_round_fill" : "circle"
            }}</i>
        </span>
        <span class="agreeCheckTxt">同意联系人手机号和邮箱接受皇家加勒比品牌资讯及优惠信息</span>
      </div>
    </div>
    <div class="room-settleAccount">
      <div v-if="isDownPayCruise" class="deposit-con">
         <img :src="`${imgUrl}/cruiseSearch/icons/deposit-currency-symbol.svg`"/>
         <span>本订单可选择订金支付￥1000/人起</span>
      </div>
      <div
        class="room-settleAccount-l js-roomDetailBtn"
        @click="isShowDetail = !isShowDetail"
      >
        <div class="total_amount" :class="{'mar-top': !isDownPayCruise}">
          <span>{{bookings.length}}间</span>
          <span class="room-settleAccount-price">￥<span class="js-totalPrice">{{totalPrice}}</span></span>
          <div class="room-settleAccount-detail">明细&nbsp;<span>&gt;</span></div>
        </div>
        <div v-if="isDownPayCruise" class="total_deposit">
            <img :src="`${imgUrl}/cruiseSearch/icons/deposit-currency-symbol-white.svg`"/>
            <span>订金预订￥1000/人起</span>
        </div>
      </div>
      <div
        class="room-settleAccount-r"
        id="orderSubmitBtn"
        @click="onSubmitBooking()"
      >
        {{allowUseTikTokCode ? "提交审核" : "提交订单"}}
      </div>
    </div>

    <div
      class="popupover orderDetail-box scroll-container"
      id="orderDetailPopup"
      v-show="isShowDetail"
    >
      <div
        class="popup-bg"
        @click="isShowDetail = false"
        @touchstart.prevent
      ></div>
      <div class="popupover-m orderDetail slideInUp">
        <div
          class="popupover-close js-orderDetailClose"
          @click="isShowDetail = false"
        >
          <img
            src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon17.png"
          />
        </div>
        <div class="popupover-title">
          <div class="popupover-title-m">
            <img
              src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon16.png"
            />
            费用明细
          </div>
        </div>
        <div class="orderDetail-m js-smartScroll">
          <div
            class="orderDetail-item"
            v-for="(booking, i) in bookings"
            :key="i"
          >
            <div class="orderDetail-item-title">
              <div class="orderDetail-item-title-num">客房{{ i + 1 }}</div>
              {{ getStateroom(booking).cnName }}
              <div class="orderDetail-item-title-roomNum">
                房间号:
                <span class="js-roomNum">
                  {{
                    booking.stateroomNumber == "GTY"
                      ? "随机"
                      : booking.stateroomNumber
                  }}
                </span>
              </div>
            </div>

            <div
              class="orderDetail-item-passenger"
              v-for="(guestPrice, j) in booking.guestPrices"
              :key="'guestPrice_' + j"
            >
              <div
                class="orderDetail-item-passenger-title orderDetail-item-txt1 js-orderDetailPassengerName"
              >
                {{ getGuestName(booking.guests, j) }}
              </div>

              <div class="orderDetail-item-row">
                <div class="orderDetail-item-txt2">零售指导价</div>
                <div class="orderDetail-item-txt3">
                  <span class="unit">¥</span>
                  <span class="js-orderRetailPer">{{
                    guestPrice.originalPrice
                  }}</span>
                </div>
              </div>
              <div class="orderDetail-item-row">
                <div class="orderDetail-item-txt2">港务税费</div>
                <div class="orderDetail-item-txt3">
                  <span class="unit">¥</span>
                  <span class="js-orderTaxPer">{{ guestPrice.taxPrice }}</span>
                </div>
              </div>
            </div>

            <div class="orderDetail-item-row orderDetail-item-row2">
              <div class="orderDetail-item-txt1">零售指导价合计</div>
              <div class="orderDetail-item-txt3">
                <span class="unit">¥</span>
                <span class="js-orderRetail">{{
                  getOriginalAmount(booking)
                }}</span>
              </div>
            </div>

            <div
              class="js-orderDetailCoupon"
              v-if="
                getDiscountItem(booking).length > 0 ||
                getObcItem(booking).length > 0
              "
            >
              <div class="orderDetail-item-coupon-title">船票优惠详情</div>
              <div class="js-orderDetailCoupon2">
                <div
                  class="orderDetail-item-row"
                  v-for="(discount, k) in getDiscountItem(booking)"
                  :key="'discount_' + k"
                >
                  <div class="orderDetail-item-txt4">
                    {{ k + 1 }}.{{ discount.description }}
                  </div>
                  <div class="orderDetail-item-txt5">
                    <span class="unit">-¥</span
                    ><span class="">{{ -discount.amount }}</span>
                  </div>
                </div>
                <div
                  class="orderDetail-item-row"
                  v-for="(obcItem, k) in getObcItem(booking)"
                  :key="'obc_' + k"
                >
                  <div class="orderDetail-item-txt4">
                    {{ getDiscountItem(booking).length + k + 1 }}.船上消费抵用金
                  </div>
                  <div class="orderDetail-item-txt5">
                    <span class="">${{ obcItem.amount }}</span>
                  </div>
                </div>
              </div>

              <div class="orderDetail-item-row orderDetail-item-row2">
                <div class="orderDetail-item-txt1">优惠后船票合计</div>
                <div class="orderDetail-item-txt3">
                  <span class="unit">¥</span>
                  <span class="js-orderCoupon">{{
                    getDiscountAmount(booking)
                  }}</span>
                </div>
              </div>
            </div>

            <div class="orderDetail-item-row orderDetail-item-row2">
              <div class="orderDetail-item-txt1">港务税费合计</div>
              <div class="orderDetail-item-txt3">
                <span class="unit">¥</span>
                <span class="js-orderTax">{{ getTaxAmount(booking) }}</span>
              </div>
            </div>
            <div class="orderDetail-item-row orderDetail-item-row2" v-if="getBirthdayPrice(booking)">
              <div class="orderDetail-item-txt1">生日礼遇</div>
              <div class="orderDetail-item-txt3">
                <span class="unit">¥</span>
                <span class="js-orderTax">{{ getBirthdayPrice(booking) }}</span>
              </div>
            </div>
            <div class="orderDetail-item-row orderDetail-item-row2" v-if="booking.groupType === 'PCPGIFT' && booking.pcpGiftInfo">
              <div class="orderDetail-item-txt1">{{booking.pcpGiftInfo.name}} x{{booking.guestNumber}}</div>
              <div class="orderDetail-item-txt3">
                <span class="unit">¥</span>
                <span class="js-orderTax">{{ booking.pcpGiftInfo.price }}</span>
              </div>
            </div>
            <div class="orderDetail-item-summary">
              <div class="orderDetail-item-txt6">合计</div>
              <div class="orderDetail-item-txt7">
                <span class="unit">¥</span>
                <span class="js-roomPrice">{{ getTotalPrice(booking) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "GuestInfoBottomPrice",
  props: {
    normalBookings: {
      type: Array,
      default() {
        return [];
      },
    },
    connectBookings: {
      type: Array,
      default() {
        return [];
      },
    },
    submitBooking: {
      type: Function,
    },
    showPrivacy: {
      type: Function,
    },
    tabHistory: {
      type: Array,
    },
    allowUseTikTokCode: {
      type: Boolean,
      default: false
    },
    isDownPayCruise: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
      isShowDetail: false,
      isAgreePolicy: false,
      bodyTop: 0,
      depositPrice: 1000,
      marketingFlagChecked: false
    };
  },
  methods: {
    getStateroom(booking) {
      if (!booking.stateroomPartRecord) {
        return {};
      }
      return booking.stateroomPartRecord;
    },
    getStateroomName(booking) {
      const stateroom = this.getStateroom(booking);
      const name = stateroom.cnName;
      let code = stateroom.stateroomCategoryCode;
      if (code.indexOf("_") >= 0) {
        code = code.split("_")[0];
      }
      let guestNumberText = "";
      switch (booking.guestNumber) {
        case 1:
          guestNumberText = "单人房";
          break;
        case 2:
          guestNumberText = "双人房";
          break;
        case 3:
          guestNumberText = "三人房";
          break;
        case 4:
          guestNumberText = "四人房";
          break;
        default:
          break;
      }
      return `${name}_${code}（${guestNumberText}）`;
    },
    getGuestName(guests, i) {
      if (!guests || !guests.guestPersons || guests.guestPersons.length <= i) {
        return `乘客${i + 1}`;
      }
      const guest = guests.guestPersons[i];
      return guest.name;
    },
    getPriceInfo(booking) {
      if (!booking.prices || !booking.prices.priceInfo) return [];
      return booking.prices.priceInfo;
    },
    getOriginalAmount(booking) {
      const originalAmount = this.getPriceInfo(booking).filter(
        (r) => r.priceTypeCode == "ORIGINAL_CRUISE_FARE"
      );
      if (originalAmount && originalAmount.length > 0) {
        return originalAmount[0].amount;
      }
      return "";
    },
    getDiscountAmount(booking) {
      const discountAmount = this.getPriceInfo(booking).filter(
        (r) => r.priceTypeCode == "DISCOUNTED_CRUISE_FARE"
      );
      if (discountAmount && discountAmount.length > 0) {
        if (discountAmount[0].amount && discountAmount[0].amount.length > 0) {
          return discountAmount[0].amount.replace("-", "");
        }
      }
      return "";
    },
    getDiscountItem(booking) {
      const discountAmount = this.getPriceInfo(booking).filter(
        (r) => r.priceTypeCode == "DISCOUNT"
      );
      if (discountAmount && discountAmount.length > 0) {
        return discountAmount[0].priceItems;
      }
      return [];
    },
    getObcItem(booking) {
      const obcItem = this.getPriceInfo(booking).filter(
        (r) => r.priceTypeCode == "ONBOARD_CREDITS"
      );
      if (obcItem && obcItem.length > 0) {
        return obcItem[0].priceItems;
      }
      return [];
    },
    getTaxAmount(booking) {
      const taxAmount = this.getPriceInfo(booking).filter(
        (r) => r.priceTypeCode == "TAXES_AND_FEES"
      );
      if (taxAmount && taxAmount.length > 0) {
        return taxAmount[0].amount;
      }
      return "";
    },
    getTotalPrice(booking) {
      const amount = this.getPriceInfo(booking).filter(
        (r) => r.priceTypeCode == "GROSS_TOTALS"
      );
      if (amount && amount.length > 0) {
        return amount[0].amount;
      }
      return "";
    },
    getBirthdayPrice(booking){
      const amount = this.getPriceInfo(booking).filter(
          (r) => r.priceTypeCode == "SPECIAL_BIRTHDAY_PRICE"
      );
      if (amount && amount.length > 0) {
        return amount[0].amount;
      }
      return "";
    },
    onSubmitBooking() {
      if (!this.isAgreePolicy) {
        this.$alert.show(
          "请您阅读并同意预订政策、《皇家游轮乘客票据合同》、《隐私政策》"
        );
        return;
      }
      this.submitBooking({marketingFlagChecked: this.marketingFlagChecked});
    },
  },
  computed: {
    totalPrice() {
      return _.sumBy(this.bookings, "netAmount").toFixed(0);
    },
    bookings() {
      return this.normalBookings.concat(this.connectBookings);
    },
    totalDeposit() {
      let deposit = 0;
      // console.log(this.bookings.stateroomPartRecord.stateroomClassPartRecord.stateroomType)
      this.bookings.forEach((row) => {
        deposit += row.guestNumber;
      });
      return this.depositPrice * deposit;
    },
    //包含套房
    isDeluxeStateroom() {
      let deluxeNum = 0;
      if(this.bookings) {
        this.bookings.forEach((row)=> {
          let stateroomType = row.stateroomPartRecord.stateroomClassPartRecord.stateroomType;
          if(stateroomType === "DELUXE") {
            deluxeNum+=1;
          }
        })
      }
      return deluxeNum > 0;
    }
  },
  watch: {
    tabHistory(newVale) {
      if (newVale.indexOf(0) >= 0 && newVale.indexOf(1) >= 0) {
        this.isAgreePolicy = true;
      }
    },
    isShowDetail(newVale) {
      this.bodyTop = window.scrollY;
      if (newVale) {
        document.body.style.position = "fixed";
        document.body.style.top = -this.bodyTop + "px";
      } else {
        document.body.style.position = "";
        document.body.style.top = "";
        window.scrollTo(0, this.bodyTop);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.orderNotesAgreeCon {
  margin-top: 10px;
  font-size: 12px;
  padding: 10px 16.5px;
  background-color: #fff;

  & .agreeCheckBtnItem {
    & + .agreeCheckBtnItem {
      margin-top: 10px;
    }
    .agreeCheckBtn {
      border-radius: 0;
      width: 14px;
      height: 14px;
      .f7-icons {
        color: #4a90e2;
        margin: 0;
        vertical-align: middle;
        font-size: 14px;
      }
    }
    .agreeCheckBtn.active .f7-icons {
      color: #4a90e2;
    }
    .agreeCheckTxt {
      color: #666;
      font-size: 12px;
      margin-left: 3px;
    }
    .agreeCheckLink {
      color: #4a90e2;
      border-bottom: 1px solid #4a90e2;
    }
  }
}
.room-settleAccount {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 21;
  width: 100%;
  overflow: hidden;
   .deposit-con {
      height: 32px;
      background: #FFF2D2;
      display: flex;
      align-items: center;
      justify-content: center;
      & > img {
            width: 12px;
            height: 12px;
            margin-right: 3px;
      }
      & > span {
            font-size: 11px;
            color: #CF7F28;
      }
  }
  & .room-settleAccount-l {
    width: 250px;
    height: 50px;
    padding: 4px 0 7px 20px;
    background-image: -webkit-gradient(linear, left top, right top, color-stop(21%, #4A90E2), to(#1A92E0));
    background-image: -webkit-linear-gradient(left, #4A90E2 21%, #1A92E0 100%);
    background-image: -moz-linear-gradient(left, #4A90E2 21%, #1A92E0 100%);
    background-image: -o-linear-gradient(left, #4A90E2 21%, #1A92E0 100%);
    background-image: linear-gradient(90deg, #4A90E2 21%, #1A92E0 100%);
    font-size: 14px;
    color: #fff;
    float: left;
    & .total_amount {
      &.mar-top {
        margin-top: 9px;
      }
      .room-settleAccount-count {
        font-family: PingFang-SC-Medium;
        /* font-size: 18px; */
        color: #FFFFFF;
        letter-spacing: 0;
      }
      &>span {
        display: inline-block;
        vertical-align: middle;
        line-height: initial;
      }
      &>span.room-settleAccount-price {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        color: #FFFFFF;
        letter-spacing: 0;
        padding: 0 6px 0 6px;
        border-left: 1px solid #fff;
        border-right: 1px solid #fff;
        margin: 0 4px 0 4px;
        display: inline-block;
        vertical-align: middle;
        line-height: 10px;
        span {
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
    & .total_deposit {
        margin-left: -2px;
        width: 112px;
        height: 16px;
        background: #00BBFE;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
      & > img {
            width: 10px;
            height: 10px;
      }
      & > span {
            font-weight: 500;
            font-size: 9px;
            color: #FFFFFF;
            margin-left: 2px;
      }
    }
    .room-settleAccount-detail {
      font-family: PingFang-SC-Medium;
      font-size: 14px;
      color: #FFFFFF;
      letter-spacing: 0;
      display: inline-block;
      vertical-align: middle;
      span {
        display: inline-block;
        color: #fff;
        font-size: 14px;
        transform: rotate(-90deg) scaleY(1.5);
        -webkit-transform: rotate(-90deg) scaleY(1.5);
        -moz-transform: rotate(-90deg) scaleY(1.5);
        -ms-transform: rotate(-90deg) scaleY(1.5);
        -o-transform: rotate(-90deg) scaleY(1.5);
      }
    }
  }
  .room-settleAccount-r {
    float: left;
    width: calc(100% - 250px);
    height: 50px;
    padding: 10px 0;
    background-image: -webkit-gradient(
      linear,
      right top,
      left top,
      from(#fad961),
      to(#febc10)
    );
    background-image: -webkit-linear-gradient(right, #fad961 0%, #febc10 100%);
    background-image: -moz-linear-gradient(right, #fad961 0%, #febc10 100%);
    background-image: -o-linear-gradient(right, #fad961 0%, #febc10 100%);
    background-image: linear-gradient(270deg, #fad961 0%, #febc10 100%);
    font-family: PingFang-SC-Medium;
    font-size: 14px;
    color: #454545;
    letter-spacing: 0;
    text-align: center;
    line-height: 29.13px;
  }
}

#orderDetailPopup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 20;
  width: 100%;
  height: 100%;
  .popup-bg {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(21, 22, 29, 0.6);
  }
  .popupover-m {
    position: absolute;
    left: 0;
    bottom: 50px;
    width: 100%;
    background-color: #f6f7f8;
    border-top: 5px solid #febc10;
    .popupover-close {
      position: absolute;
      right: 0;
      top: -1px;
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -moz-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -moz-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      width: 30px;
      height: 30px;
      background-color: #febc10;
      border-bottom-left-radius: 5px;
      img {
        width: 17px;
      }
    }
    .popupover-title {
      padding: 25px 20px 0;
      background-color: #fff;
      .popupover-title-m {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding-bottom: 11px;
        font-size: 14px;
        line-height: 20px;
        color: #4a90e2;
        border-bottom: 1px solid #e5e5e5;
        img {
          display: block;
          width: 15px;
          margin-right: 5px;
        }
      }
    }
    .orderDetail-m {
      max-height: 60vh;
      overflow-y: auto;
      .orderDetail-item {
        margin-bottom: 10px;
        padding: 19px 20px 13px;
        background-color: #fff;
        .orderDetail-item-title {
          display: -webkit-box;
          display: -webkit-flex;
          display: -moz-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -webkit-align-items: center;
          -moz-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          padding-bottom: 12px;
          font-size: 14px;
          line-height: 20px;
          color: #333;
          .orderDetail-item-title-num {
            margin-right: 6px;
            padding: 0 8px;
            background-color: rgba(74, 144, 226, 0.15);
            border-radius: 10px;
          }
          .orderDetail-item-title-roomNum {
            margin-left: 19px;
          }
        }

        .orderDetail-item-passenger {
          margin-bottom: 12px;
          padding-bottom: 3px;
          border-bottom: 1px solid #d8d8d9;
          .orderDetail-item-passenger-title {
            margin-bottom: 8px;
          }
        }
        .orderDetail-item-row {
          display: -webkit-box;
          display: -webkit-flex;
          display: -moz-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-pack: justify;
          -webkit-justify-content: space-between;
          -moz-box-pack: justify;
          -ms-flex-pack: justify;
          justify-content: space-between;
          -webkit-box-align: center;
          -webkit-align-items: center;
          -moz-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          padding-left: 18px;
          padding-bottom: 9px;
        }
        .orderDetail-item-txt1 {
          font-size: 14px;
          line-height: 20px;
          color: #333;
          font-weight: bold;
        }
        .orderDetail-item-txt2 {
          font-size: 12px;
          line-height: 16px;
          color: #333;
        }
        .orderDetail-item-txt3 {
          font-size: 12px;
          line-height: 14px;
          color: #333;
          .unit {
            font-size: 10px;
            line-height: 14px;
            color: #333;
          }
        }
        .orderDetail-item-txt4 {
          font-size: 12px;
          line-height: 16px;
          color: #4a90e2;
        }
        .orderDetail-item-txt5 {
          font-size: 12px;
          line-height: 14px;
          color: #4a90e2;
        }
        .orderDetail-item-txt6 {
          margin-right: 8px;
          font-size: 12px;
          line-height: 16px;
          color: #333;
          font-weight: bold;
        }
        .orderDetail-item-txt7 {
          font-size: 14px;
          line-height: 14px;
          color: rgba(255, 80, 85, 1);
          font-weight: bold;
          .unit {
            font-size: 10px;
            line-height: 14px;
          }
        }
        .orderDetail-item-row2 {
          padding-left: 0;
        }

        .orderDetail-item-coupon-title {
          padding-bottom: 7px;
          font-size: 14px;
          line-height: 20px;
          color: #4a90e2;
          font-weight: bold;
        }
        .orderDetail-item-summary {
          display: -webkit-box;
          display: -webkit-flex;
          display: -moz-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-pack: end;
          -webkit-justify-content: flex-end;
          -moz-box-pack: end;
          -ms-flex-pack: end;
          justify-content: flex-end;
          -webkit-box-align: baseline;
          -webkit-align-items: baseline;
          -moz-box-align: baseline;
          -ms-flex-align: baseline;
          align-items: baseline;
          margin-top: 3px;
          padding-top: 13px;
          border-top: 1px solid #d8d8d9;
        }
      }
      .orderDetail-item:last-child {
        margin-bottom: 0px;
      }
    }
  }

  .slideInUp {
    -webkit-animation-fill-mode: both;
    -moz-animation-fill-mode: both;
    -o-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-name: slideInUp;
    -moz-animation-name: slideInUp;
    -o-animation-name: slideInUp;
    animation-name: slideInUp;
    -webkit-animation-duration: 0.5s;
    -moz-animation-duration: 0.5s;
    -o-animation-duration: 0.5s;
    animation-duration: 0.5s;
  }
}
</style>
